<template>
  <div class="box7">
    <pageTitle title="百万粉丝大V  &nbsp;7至10年行业大牛亲自带队" 
    tit="用实力诠释、用事实证明，抽丝剥茧带你揭秘运营底层逻辑"
    titleColor="#000000"
      titColor="#333333"
     />

    <div class="content common-animation">
      <div class="left-btn" @click="prevPage"></div>
      <div class="right-btn" @click="nextPage"></div>
      <!-- 讲师信息 -->
      <el-carousel
        :autoplay="isAutoPlay"
        :loop="true"
        :arrow="'never'"
        :initial-index="0"
        :interval="3000"
        ref="carousel"
        type="card"
        height="400px;"
      >
        <el-carousel-item v-for="(item, index) in teacherList" :key="index">
          <div
            class="item-img"
            :style="
              `background-image: url(` +
              require(`@/assets/topic-page/newMedia2/box6/${index + 1}.png`) +
              `)`
            "
          ></div>
          <div class="item-info">
            <div class="name">{{ item.name }}</div>
            <div class="teachInfo">{{item.teachInfo}}</div>
            <div class="tag">项目业绩</div>
            <div class="teachInfo">{{item.performanceInfo}}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="btn" @click="childMethod">更多师资信息</div>
  </div>
</template>

<script>
import pageTitle from "../../../components/common/pageTitle.vue";
export default {
  components: {
    pageTitle
  },
  data() {
    return {
      isAutoPlay: true,
      timer: null,

      realIndex: 0, //选中的讲师
      initialWidth: 0, //初始样式
      initialLeft: 0, //滚动条初始位置
      isClick: false, // 点击滚动条后才能拖动

      teacherList: [
      {
          name: "短视频运营婧姐",
          teachInfo:"运营过抖音、火山、西瓜、微视等多个上百万粉丝大号，通过短视频营销策略帮助企业快速打开市场。两周时间在抖音平台吸引精准粉丝10w+。",
          performanceInfo:'服务1000+学员，擅长短视频直播变现，曾帮助多位学员实现1个月涨粉20w+,变现100w+。'
        },
         {
          name: "船长老师",
          teachInfo:"运营十余微信公众平台，全网累计粉丝超百万，为企业带来千万收益，为上百企业搭建新媒体运营渠道。",
          performanceInfo:'曾帮助学员口播账号半年涨粉320w，最高播放量达4000w，月引流3万人进入私域变现，月利润高达300w，擅长口播类，种草类账号的运营。'
        },
        {
          name: "赵老师",
          teachInfo:"百度、苏宁多年大厂互联网工作经验，独立制作的短视频直播教学课程，并组建线下培训课。",
          performanceInfo:'孵化过5万+的粉丝账号超10个，且变现可观。运营过2个百万粉丝大号+2个同时在线超千人的直播间。北抖会创始人，45天起号【野哥短视频】，多条百万播放作品。'
        },
         {
          name: "抖音分析师作者",
          teachInfo:"曾帮助过3000+短视频账号分析内容优化，通过8小时粉丝裂变，微信涨粉20倍。利用自创方法在搜索引擎霸屏每月为企业带来50万IP流量，月销售额提升50%以上。",
          performanceInfo:'擅长技术手段拉动运营数据，挖掘平台漏洞，曾利用搜索引擎bug，日引流1w+意向用户到企业网站，自主研发抖音分析师、微信裂变工具。'
        },
        {
          name: "零度老师",
          teachInfo:"红粉笔联合创始人，曾在中山大学、河北经贸大学等二十余所高校讲授短视频、电商实训项目。具有多个领域商业变现经验，涵盖教育、娱乐、剧情、旅行、电商种草等领域。",
          performanceInfo:'指导众多学员项目案例，学员零启动美食账号单个作品涨粉20w+、零启动新奇特特效账号首作品流量破100w+。'
        },
      ]  
    };
  },
  methods: {
    prevPage() {
      // this.$refs.carousel.autoplay = false;
      this.$refs.carousel.prev();
      this.isAutoPlay = false;
      this.timer = setTimeout(() => {
        this.isAutoPlay = true;
      }, 500);
    },
    nextPage() {
      this.$refs.carousel.next();
      this.isAutoPlay = false;
      // this.$refs.carousel.autoplay = false;
      this.timer = setTimeout(() => {
        this.isAutoPlay = true;
      }, 500);
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    childMethod() {
      this.$parent.itcastClick();
    }
  }
};
</script>

<style lang="scss" scoped>
.box7 {
  margin: 0 auto;
  padding: 80px 0px;
  max-width: 2048px;
  background: url("../../../assets/topic-page/newMedia2/box6/bg.jpg") no-repeat;
  background-size: 2300px auto;
  background-position:top center;
}
.btn{
  width: 207px;
  height: 56px;
  font-size: 20px;
  color: #fff;
  text-align: center;
  line-height: 56px;
  border-radius: 28px;
  font-weight: bold;
  box-sizing: border-box;
  box-shadow: 0 8px 7px #e2b8db;
  background: url("../../../assets/topic-page/newMedia2/btnbg1.png") no-repeat;
  cursor: pointer;
  margin: 30px auto 0;
  padding-right: 20px;
  &:hover{
    box-shadow: none;
  }
}

::v-deep.el-carousel--horizontal {
  overflow-x: hidden;
  padding: 49px 0px 0;
}
::v-deep .el-carousel__container {
  position: relative;
  height: 400px;
}
.content {
  position: relative;
  margin: 0 auto;
  width: 1200px;

  .left-btn {
    position: absolute;
    top: 50%;
    left: 1px;
    width:49px;
    height: 49px;
   
    background-image: url("../../../assets/topic-page/newMedia2/box6/icon-left.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    cursor: pointer;
    z-index: 9;
    &:hover {
     
      background-image: url("../../../assets/topic-page/newMedia2/box6/icon-left-grey.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
    }
  }

  .right-btn {
    position: absolute;
    top: 50%;
    right: 1px;
    width: 49px;
    height: 49px;
    
    background-image: url("../../../assets/topic-page/newMedia2/box6/icon-right.png");
    background-repeat: no-repeat;
    cursor: pointer;
    background-size: 100% 100%;
    background-position: center;
    z-index: 9;
    &:hover {
     
      background-image: url("../../../assets/topic-page/newMedia2/box6/icon-right-grey.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
    }
  }

  .item-img {
    position: relative;
    margin-right: 35px;
    max-width: 285px;
    min-width: 285px;
    height: 320px;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 8px;
    overflow: hidden;
    z-index: 3;
  }

  .name {
    margin-bottom: 16px;

    font-family: PingFang-SC-Heavy;
	font-size: 22px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 36px;
	letter-spacing: 0px;
	color: #ff3377;
  }
  .teachInfo{
    font-family: PingFang-SC-Regular;
	font-size: 16px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 32px;
	letter-spacing: 1px;
	color: #555266;
  }
  .tag{
    font-family: PingFang-SC-Medium;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 30px;
	letter-spacing: 1px;
		color: #ffffff;
  width: 97px;
	height: 30px;
	background-image: linear-gradient(-45deg, 
		#ffb2cc 0%, 
		#ffccdd 100%);
	border-radius: 6px;
  margin: 30px 0 20px;
  text-align: center;
  }

  
}

.el-carousel__item {
  display: flex;
  align-items: center;
  padding-left: 35px;
  padding-right: 60px;
  // height: 365px;
	box-shadow: 0px 0px 40px 0px 
		#ffeae5;
 border-radius: 20px;
  background: #fff;
  opacity: 0;
  // opacity: 1;
  box-sizing: border-box;

  .item-info {
    padding-right: 60px;
    min-width: 500px;
  }
  // .item-img {
  //   min-width: 90px;
  // }
}

.el-carousel__item.is-in-stage {
  opacity: 0.5;
  .item-info {
    margin-left: -307px;
    min-width: 500px;
  }
}

.el-carousel__item.is-active {
  opacity: 1;
  transform: translateX(100px) scale(1) !important;
  width: 980px;
  height: 400px;
  // background: #ffffff;
  background-color: #ffffff;
  box-shadow: 0px 0px 40px 0px 
		#ffeae5;
	border-radius: 20px;
  cursor: pointer;
  .item-info {
    margin-left: 0px;
    min-width: 500px;
  }
  .item-img {
    width: 284px;
    height: 320px;
    background-color: #e0edff;
    border-radius: 10px;
  }
}

::v-deep.el-carousel__indicators {
  display: none;
}
</style>